import dayjs from 'dayjs';

export interface StayValidationResult {
  isShowError: boolean;
  errorMsg: string;
  errorInfo: string;
}

export interface StayValidationParams {
  arrivalDate: string | undefined;
  isAuthorMode: boolean;
  confirmationNumber: string | null;
  marshaCode: string | null;
  errorData?: { show?: boolean; status?: string; url?: string } | null;
  propertyConfigError?: string;
  errorMessage?: string;
}

export const validateStayNotStarted = (params: StayValidationParams): StayValidationResult => {
  let errorMsg = params.errorMessage ?? 'noError';
  let errorInfo = '';
  let isShowError = false;

  if (params.confirmationNumber) {
    if (errorMsg === 'noError' && !params.errorData) {
      errorMsg = params.propertyConfigError ?? 'noError';
    }

    const isBeforeArrival = dayjs().isBefore(dayjs(params.arrivalDate).format('MMM DD, YYYY'));

    if (errorMsg === 'noError') {
      if ((params.errorData && !params.isAuthorMode) || params.confirmationNumber === '' || params.marshaCode === '') {
        errorInfo = `API|${params.errorData?.status}|${params.errorData?.url}|GET`;
        errorMsg = 'Invalid or missing request parameters.';
      } else if (!isBeforeArrival && !params.isAuthorMode) {
        errorMsg = 'Stay Already Started';
      }
    }

    if (errorMsg !== 'noError') {
      isShowError = true;
    }
    if (params.confirmationNumber === 'accDemo' || params.confirmationNumber === 'appBuilderDemo') {
      isShowError = false;
    }
  } else {
    if ((params.errorData && !params.isAuthorMode) || params.confirmationNumber === '') {
      errorInfo = `API|${params.errorData?.status}|${params.errorData?.url}|GET`;
      errorMsg = 'Invalid or missing request parameters.';
      isShowError = true;
    }
  }

  return { isShowError, errorMsg, errorInfo };
};
